__turbopack_context__.v({
  "freeButton": "index-module-scss-module__pJL_yq__freeButton",
  "freeContinue": "index-module-scss-module__pJL_yq__freeContinue",
  "loading": "index-module-scss-module__pJL_yq__loading",
  "purchaseDetails": "index-module-scss-module__pJL_yq__purchaseDetails",
  "reduniq": "index-module-scss-module__pJL_yq__reduniq",
  "summaryBox": "index-module-scss-module__pJL_yq__summaryBox",
  "title": "index-module-scss-module__pJL_yq__title",
  "totalWrapper": "index-module-scss-module__pJL_yq__totalWrapper",
});
